module.exports = __webpack_public_path__ + "img/xgNursingHome.95c0d44d.jpg";